import { Button, List } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded } from 'react-redux-firebase'
import { withStateHandlers } from 'recompose'
import { compose } from 'redux'

import { fsCollections } from '../../helpers/firestore'

import { deleteTournamentHelper } from '../../helpers/delete-tournament'
import { Tournament } from '../../schemas/Tournament'
import './TournamentList.css'
import { TournamentListItem } from './TournamentListItem'

type TournamentListProps = {
  baseUrl: string
  tenant: string
  admin: boolean
  tournaments: Tournament[]
  removeTournament(): void
  showMore(): void
}

class TournamentList extends React.Component<TournamentListProps, any> {
  // https://medium.freecodecamp.org/react-pattern-extract-child-components-to-avoid-binding-e3ad8310725e
  renderListItem = (tourney) => {
    const { tenant, admin, removeTournament } = this.props

    return (
      <TournamentListItem
        admin={admin}
        tenant={tenant}
        tourney={tourney}
        removeTournament={removeTournament}
      />
    )
  }

  render() {
    const { tournaments } = this.props

    return (
      <div className="TournamentList">
        <List
          itemLayout="vertical"
          size="default"
          loading={!isLoaded(tournaments)}
          dataSource={tournaments || []}
          renderItem={this.renderListItem}
        />
        <Button onClick={this.props.showMore}>Show more</Button>
      </div>
    )
  }
}

export default compose<FIXME>(
  withStateHandlers<FIXME, FIXME>(
    ({ defaultNumberOfItems = 10 }) => ({
      numberOfItems: defaultNumberOfItems,
    }),
    {
      showMore: ({ numberOfItems, defaultNumberOfItems = 10 }) => () => ({
        numberOfItems: numberOfItems + defaultNumberOfItems,
      }),
    },
  ),
  firestoreConnect<FIXME>(({ tenant, admin, numberOfItems }) => [
    {
      collection: fsCollections.tournaments(tenant),
      where: admin ? [] : ['public', '==', true],
      orderBy: ['dateFrom', 'desc'],
      limit: numberOfItems,
    },
  ]),
  connect(({ firestore, firebase: { profile, auth } }: FIXME, { tenant }: FIXME) => ({
    tournaments: firestore.ordered[fsCollections.tournaments(tenant)],
    profile,
    auth,
  })),
  deleteTournamentHelper,
)(TournamentList)



// WEBPACK FOOTER //
// ./src/components/tournament/TournamentList.tsx